var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.677,
    height: 33.416,
    viewBox: "0 0 33.677 33.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.911,
    x2: 1.198,
    y2: 0.085,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1793",
    "data-name": "Trac\\xE9 1793",
    d: "M119.088,286.248H112.45V284.7a.849.849,0,0,0-.847-.847h-.363a.849.849,0,0,0-.847.847v1.547h-6.777V284.7a.849.849,0,0,0-.847-.847h-.363a.849.849,0,0,0-.847.847v1.547H94.592a4.6,4.6,0,0,0-4.59,4.59V312.68a4.6,4.6,0,0,0,4.59,4.59h24.5a4.6,4.6,0,0,0,4.59-4.59V290.838A4.6,4.6,0,0,0,119.088,286.248Zm-24.5,2.2h6.969v.5a.849.849,0,0,0,.847.847h.363a.849.849,0,0,0,.847-.847v-.5h6.777v.5a.849.849,0,0,0,.847.847h.363a.849.849,0,0,0,.847-.847v-.5h6.638a2.391,2.391,0,0,1,2.389,2.388v6.519H92.2v-6.519A2.391,2.391,0,0,1,94.592,288.449ZM102.66,306.1v-7.219h8.849V306.1Zm8.849,1.524v7.445H102.66v-7.445ZM101.136,306.1H92.2v-7.219h8.933Zm11.9-7.219h8.444V306.1h-8.444ZM92.2,312.68v-5.056h8.933v7.445H94.592A2.391,2.391,0,0,1,92.2,312.68Zm26.885,2.389h-6.056v-7.445h8.444v5.056A2.391,2.391,0,0,1,119.088,315.069Z",
    transform: "translate(-90.002 -283.854)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIconColor);
export default __webpack_public_path__ + "static/media/eventsIconColor.c8cefb534c35387bc1e593044dd7be4e.svg";
export { ForwardRef as ReactComponent };